import { callGet, callPost, callDelete, callPut } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const allPumps = async (token) => {
  return await callGet(REQ.CEO.ALL_PUMPS, token);
};

